import { validEmail } from './helpers';

// See resources/assets/js/shared/components/jobsite/VacancyAlerts.vue for the markup this drives.
// checkEmailUrl/optionsUrl/subscribeUrl and recaptchaSiteKey are baked in at SSR-render time
// (they're static per request), same as window.jobComponent bakes in its job list.
window.vacancyAlertsComponent = function ({
    recaptchaSiteKey,
    checkEmailUrl,
    optionsUrl,
    subscribeUrl,
    selectedDepartments = [],
    selectedLocations = [],
}) {
    return {
        email: null,
        emailError: null,
        togglingPopup: false,
        popupVisible: false,

        animationActive: false,
        randomInterval: null,
        resetInterval: null,

        departments: [],
        locations: [],
        selectedDepartments,
        selectedLocations,
        dropdownOpen: { departments: false, locations: false },

        sending: false,
        error: null,

        init() {
            this.startRandomInterval();
            this.resetInterval = setInterval(() => this.startRandomInterval(), 5000);
        },

        destroy() {
            clearInterval(this.randomInterval);
            clearInterval(this.resetInterval);
        },

        getRandomDelay() {
            // Random delay between 3 and 5 seconds
            return Math.floor(Math.random() * 2000) + 3000;
        },

        startRandomInterval() {
            clearInterval(this.randomInterval);
            this.randomInterval = setInterval(() => {
                this.animationActive = true;
                setTimeout(() => {
                    this.animationActive = false;
                }, 1000); // Animation duration of 1 second
            }, this.getRandomDelay());
        },

        isEmailValid() {
            return validEmail(this.email);
        },

        togglePopup() {
            if (this.popupVisible) {
                this.popupVisible = false;
                return;
            }
            if (this.emailError) this.emailError = null;
            if (!this.isEmailValid()) return;

            this.togglingPopup = true;
            axios.post(checkEmailUrl, { email: this.email })
                .then(() => this.fetchOptions().then(() => {
                    this.popupVisible = true;
                }))
                .catch(err => {
                    this.emailError = err.response.data.message;
                })
                .finally(() => {
                    this.togglingPopup = false;
                });
        },

        fetchOptions() {
            return axios.get(optionsUrl).then(res => {
                this.departments = res.data.data.departments;
                this.locations = res.data.data.locations;
            });
        },

        listKey(target) {
            return target === 'departments' ? 'selectedDepartments' : 'selectedLocations';
        },

        toggleDropdownSelect(target, id) {
            const key = this.listKey(target);
            this[key] = this[key].includes(id)
                ? this[key].filter(i => i !== id)
                : [...this[key], id];
        },

        removeDropdownItem(target, id) {
            const key = this.listKey(target);
            this[key] = this[key].filter(i => i !== id);
        },

        toggleLocationCheckbox(id) {
            this.selectedLocations = this.selectedLocations.includes(id)
                ? this.selectedLocations.filter(i => i !== id)
                : [...this.selectedLocations, id];
        },

        validateAndSend(withPreferences = true) {
            if (this.error) this.error = null;
            this.sending = true;

            // Use recaptcha v3 to validate the user, if validated by it, send request to backend to send the email to the user
            grecaptcha.enterprise.ready(async () => {
                const token = await grecaptcha.enterprise.execute(recaptchaSiteKey, { action: 'vacancy_alerts' });

                axios.post(subscribeUrl, {
                    email: this.email,
                    department_ids: withPreferences ? this.selectedDepartments : [],
                    location_ids: withPreferences ? this.selectedLocations : [],
                    recaptcha_token: token,
                }).then(res => {
                    this.popupVisible = false;
                    this.email = null;
                    this.selectedDepartments = [];
                    this.selectedLocations = [];
                    window.addToast(res.data.message, {
                        type: 'success',
                        duration: 5000,
                    });
                }).catch(err => {
                    this.error = err.response.data.message;
                }).finally(() => {
                    this.sending = false;
                });
            });
        },
    };
};
